import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import './assets/css/main.css';
import './assets/vendor/font-awesome-4.7/css/font-awesome.min.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    <Suspense fallback={
      <div>Loading...</div>
    }>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Suspense>
  </>
);
